import type { ValidationResult } from "@unique-wool/specs-validation";
import { validateFabrics } from "@unique-wool/specs-validation";
import { ObservableModelRoot } from "./observable";
import type {
  FabricSpecsModelValidationContext,
  FabricSpecsModelSnapshot,
  SpecsCatalog,
} from "./types";
import { SpecsFabricModel } from "./fabrics/SpecsFabricModel";
import { SpecsFabricColorModel } from "./fabrics/SpecsFabricColorModel";

export class SpecsFabricsModel extends ObservableModelRoot {
  fabric!: SpecsFabricModel;
  private validationContext!: FabricSpecsModelValidationContext;

  constructor() {
    super();
    this.defineObservableValue("fabric", new SpecsFabricModel());
    this.fabric.factory = "AT";
    this.fabric.defaultColor = new SpecsFabricColorModel();
    this.validationContext = {};
  }

  restore(snapshot: FabricSpecsModelSnapshot) {
    this.fabric.restore(snapshot);
    return this;
  }

  save(): FabricSpecsModelSnapshot {
    return this.fabric.save();
  }

  setValidationContext(context: FabricSpecsModelValidationContext = {}) {
    this.validationContext = context;
    return this;
  }

  buildValidationSpecs() {
    return {
      families: [],
      fabrics: [this.save()],
      decorations: [],
      products: [],
    };
  }

  async validate(): Promise<ValidationResult> {
    const issues = await validateFabrics(this.buildValidationSpecs());
    return {
      valid: issues.length === 0,
      issues,
    };
  }

  static fromCatalog(specs: SpecsCatalog, fabricName: string) {
    const fabric = Array.isArray(specs.fabrics)
      ? specs.fabrics.find((candidate) => candidate.name === fabricName)
      : null;

    if (!fabric) {
      return null;
    }

    return new SpecsFabricsModel().restore(fabric as FabricSpecsModelSnapshot);
  }
}
